import { useValidations } from "@sttedra_ui/framework";
import { searchValue } from "@/composables/_commons/helper.js";

const { required } = useValidations();

export default function (object = null) {
  let disableOrder = false;

  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const element = object[key];

      if (element.name == "orden" && element.value === 0) {
        disableOrder = true;
      }
    }
  }

  return {
    items: [
      {
        field: "titulo",
        label: "Nombre",
        value: searchValue(object, "titulo"),
        rules: { required },
        classObj: ["col-12"],
      },
      {
        field: "aliasCategoria",
        label: "Alias",
        value: searchValue(object, "aliasCategoria"),
        rules: { required },
        classObj: ["col-12 md:col-8"],
        properties: {
          disabled: object != null,
        },
      },
      {
        field: "orden",
        label: "Orden",
        value: searchValue(object, "orden"),
        rules: { required },
        classObj: ["col-12 md:col-4"],
        type: "inputnumber",
        properties: {
          disabled: disableOrder,
          min: 1,
        },
      },
      {
        field: "descripcion",
        label: "Descripción",
        value: searchValue(object, "descripcion"),
        type: "textarea",
        classObj: ["col-12"],
      },
    ],
  };
}
